"use client";

import { useState, type ReactNode } from "react";
import AccordionItem from "@/components/AccordionItem";

/**
 * The single canonical FAQ accordion used across the site - the dedicated
 * /faq page, the calculators, district/residence pages and the
 * map/alerts/chat SEO landings all render their FAQ through this so the
 * look is identical everywhere.
 *
 * One item open at a time. Answers always render in the DOM (collapsed via
 * height, not removed), so they stay in the SSR HTML for crawlers and the
 * FAQPage rich result.
 */
export default function FaqList({ entries }: { entries: Array<{ q: string; a: string; extra?: ReactNode }> }) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggle = (i: number) => setOpenIndex((prev) => (prev === i ? null : i));
  return (
    <div className="space-y-3">
      {entries.map((entry, i) => (
        <AccordionItem
          key={i}
          question={entry.q}
          answer={entry.a}
          extra={entry.extra}
          isOpen={openIndex === i}
          onToggle={() => toggle(i)}
        />
      ))}
    </div>
  );
}
